import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import './AuthForms.css'
import axios from 'axios';
import logo from '../assets/logo-mobile.png'
import { useAlertContext } from '../../context/alertContext';
import Alert from '../Alert/Alert';

function SignIn(props) {

  const { showAlert } = useAlertContext()
  const [signIn, setSignIn] = useState({});

  const handleChangeSignin = (event) => {
    const name = event.target.name;
    const value = event.target.value;
    setSignIn(values => ({ ...values, [name]: value }))
  }

  function goToTop() {
    window.scroll(0, 0);
  }

  const handleSubmitSignIn = (event) => {
    event.preventDefault()
    const url = 'https://tbc-backend.up.railway.app/user/login'
    const headers = { "Content-Type": "application/json" }
    const data = {
      email: signIn.email,
      password: signIn.password
    }

    axios.post(url, data, { headers }).then((res) => {
      goToTop()
      showAlert('You have signed in Successfully, Thanks!', 'success', '#check-circle-fill')
      // setTimeout(() => {
        props.handleLogin()
        // }, 2000);
        localStorage.setItem("email", signIn.email);
        setSignIn({});
    }
    ).catch((err) => {
      if (err.response.status === 404) {
        showAlert('User not found! Please Register first, Thanks  ', 'danger', '#exclamation-triangle-fill')
      } else if (err.response.status === 409) {
        showAlert('Incorrect password, Please try Again!', 'warning', '#exclamation-triangle-fill')
      }
      // console.log(err);
    })
  }
  props.email(signIn.email)

  return (
    <>

      <Alert mT='20px' mR='20px' />
      <section className="form-bg mt-0 mt-lg-5 bg-white pt-5">
        <div className="container h-custom ">
          <div className="d-flex justify-content-center align-items-center h-100 ">
            <div className="col-md-8 col-lg-5 col-xl-5 col-11 ms-xl-5  p-sm-5 p-2 pt-0 form-body rounded border border-dark">
              <div className='text-center '>
                <img className='bg-dark mt-5 img-fluid mx-auto mb-4 w-75' src={logo} alt="" />
                <p className='pt-3 fs-5 fw-semibold'>WELCOME TO TBC EXPERTS</p>
              </div>
              <form onSubmit={handleSubmitSignIn}>
                <div className="divider d-flex align-items-center my-4">
                </div>
                <div className="form-outline mb-4">
                  <label className="form-label" htmlFor="form3Example3">
                    Email address
                  </label>
                  <input
                    type="email"
                    id="form3Example3"
                    className="form-control form-control-lg"
                    placeholder="Enter a valid email address"
                    onChange={handleChangeSignin}
                    value={signIn.email || ""}
                    name='email'
                  />
                </div>
                <div className="form-outline mb-3">
                  <label className="form-label" htmlFor="form3Example4">
                    Password
                  </label>
                  <input
                    type="password"
                    id="form3Example4"
                    className="form-control form-control-lg"
                    placeholder="Enter password"
                    onChange={handleChangeSignin}
                    value={signIn.password || ""}
                    name='password'
                  />
                </div>

                <div className="text-center text-lg-start mt-4 pt-2">
                  <input
                    type="submit"
                    className="btn btn-primary btn-lg"
                    style={{ paddingLeft: "2.5rem", paddingRight: "2.5rem" }}
                    value='Login'
                  />
                  <p className="small fw-bold mt-2 pt-1 mb-0">
                    Don't have an account?{" "}
                    <Link to='/signup' className="link-danger">
                      Register
                    </Link>
                  </p>
                </div>
              </form>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}

export default SignIn;
